import styled from 'styled-components'

const backgrounds = {
  add: '#e8f8ec',
  remove: '#fdecec',
}

const borders = {
  add: '#b7ebc6',
  remove: '#f5c6cb',
}

export const Block = styled.div`
  background: ${({ $tone }) => backgrounds[$tone] || 'transparent'};
  border: 1px solid ${({ $tone }) => borders[$tone] || '#dadee4'};
  border-radius: 0.2rem;
  padding: 0.4rem 0.5rem;
  margin-bottom: 0.4rem;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  img {
    -webkit-user-drag: none;
    user-select: none;
  }

  .avatar-md {
    width: 2rem;
    height: 2rem;
    font-size: 1rem;
    flex: none;
  }
`

export const Top = styled.div`
  display: flex;
  align-items: flex-start;
`

export const Identity = styled.div`
  min-width: 0;
  flex: 1;
  margin-left: 0.45rem;
  line-height: 1.25;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.35rem;
`

export const ChipButton = styled.button`
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin-left: auto;
  padding: 0.08rem 0.45rem;
  border-radius: 999px;
  border: 1px ${({ $empty }) => ($empty ? 'dashed #c5cad3' : 'solid #d5dbe3')};
  background: ${({ $empty }) => ($empty ? 'transparent' : 'rgba(255, 255, 255, 0.85)')};
  color: ${({ $empty }) => ($empty ? '#8b95a5' : '#455060')};
  font-size: 0.7rem;
  line-height: 1.4;
  cursor: pointer;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 0.3rem;
  }

  .fa-pen {
    font-size: 0.6rem;
    color: #8b95a5;
  }
`
